<div class="modal-header justify-content-between">
    <h4 class="modal-title header-13">
     {{configs.title}}
    </h4>
    <div>
      <button
      type="button"
      class="accello-icon-btn"
      (mousedown)="isActive = true"
      (mouseup)="isActive = false"
      (mouseleave)="isActive = false"
      (click)="activeModal.dismiss('Cross click')"
    >
      <img
        [src]="
          isActive
            ? 'assets/images/virtusa-icons/close-dark.svg'
            : 'assets/images/virtusa-icons/close.svg'
        " alt="close"
      />
    </button>
    </div>
  </div>
  
  <div class="detailed-content">
    <div>
        <app-dynamic-form [form]="dynamicForm" [formFields]="fields"></app-dynamic-form>

        <div>
            <div class="my-3 d-flex expansion-wrapper">
                <mat-icon class="expand-icon cursor-pointer" (click)="expand()" (keydown)="expand()" [ngClass]="{ 'rotate': !isExpanded }"> keyboard_arrow_up </mat-icon>
                <span class="cursor-pointer" (click)="expand()" (keydown)="expand()"> Add Authorization (Optional)  </span>
            </div>

            <div *ngIf="isExpanded">
                <div class="cont-group rounded v-center p-3" [ngClass]="{ 'active': authenticationType === 'basic' }" (click)="onAuthTypeChange('basic')" (keydown.enter)="onAuthTypeChange('basic')">
                    <div class="d-flex">
                        <input [(ngModel)]="authenticationType" value="basic" type="radio" id="basic">
                        <label for="basic" class="cont-title mx-1"> Basic Authentication Configuration </label>
                    </div>

                    <div class="mt-3 inp-wrapper">
                        <div class="d-flex">
                            <span class="w-50"> Username </span>
                            <input type="text" [(ngModel)]="data.username" class="form-control" placeholder="Add username">
                        </div>
                        <div class="d-flex mt-2">
                            <span class="w-50"> Password </span>
                            <input type="password" [(ngModel)]="data.password" class="form-control" placeholder="Add password">
                        </div>
                    </div>
                </div>

                <div class="cont-group rounded v-center p-3 mt-2" [ngClass]="{ 'active': authenticationType === 'OAUTH' }" (click)="onAuthTypeChange('OAUTH')" (keydown.enter)="onAuthTypeChange('OAUTH')">
                    <div class="d-flex">
                        <input [(ngModel)]="authenticationType" value="OAUTH" type="radio" id="OAUTH">
                        <label for="OAUTH" class="cont-title mx-1"> OAuth Configuration </label>
                    </div>

                    <div class="mt-3 inp-wrapper">
                        <div class="d-flex">
                            <span class="w-50"> Auth URL </span>
                            <input type="text" [(ngModel)]="data.authUrl" class="form-control" placeholder="Add auth URL">
                        </div>
                        <div class="d-flex mt-2">
                            <span class="w-50"> Access Token URL </span>
                            <input type="text" [(ngModel)]="data.accessTokenUrl" class="form-control" placeholder="Add access token URL">
                        </div>
                        <div class="d-flex mt-2">
                            <span class="w-50"> Client ID </span>
                            <input type="password" [(ngModel)]="data.clientId" class="form-control" placeholder="Add client ID">
                        </div>
                        <div class="d-flex mt-2">
                            <span class="w-50"> Client Secret </span>
                            <input type="password" [(ngModel)]="data.clientSecret" class="form-control" placeholder="Add client secret">
                        </div>
                        <div class="d-flex mt-2">
                            <span class="w-50"> Scope (Optional) </span>
                            <input type="text" [(ngModel)]="data.scope" class="form-control" placeholder="Add comma seperated scope values" (blur)="processScopeInput()" (keydown.enter)="processScopeInput()">
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
  </div>

  <div class="modal-footer border-0">
    <div class="d-flex justify-content-end">
      <button
        class="btn-accello-secondary  mx-2 open-btn"
        (click)="activeModal.dismiss('Cross click')"
      >
        Cancel
      </button>
      <button
        class="btn-accello-primary-light open-btn"
        (click)="save()"
      >
        {{configs.saveBtnText}}
      </button>
    </div>
  </div>
  